import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const LawyerDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [lawyer, setLawyer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLawyerDetails = async () => {
      try {
        const advocateId = location.state?.advocateId;
        if (!advocateId) {
          setError("No lawyer ID provided");
          setLoading(false);
          return;
        }

        const token = localStorage.getItem("token");
        const response = await fetch(
          `https://admindashboard.clns.in/api/dashboard/single_advocate/?advocate_id=${advocateId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch lawyer details");
        }

        const data = await response.json();
        setLawyer({
          ...data.advocate_details,
          case_counts: data.case_counts,
          internship_counts: data.internship_counts,
        });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchLawyerDetails();
  }, [location.state]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error || !lawyer) {
    return <div>Error: {error || "No Lawyer Data Available"}</div>;
  }

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <button
        onClick={() => navigate("/lawyers#")}
        style={{
          marginBottom: "20px",
          padding: "10px",
          backgroundColor: "#007bff",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        ← Back
      </button>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: "20px",
        }}
      >
        <thead>
          <tr>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>
              Lawyer Name
            </th>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>
              Phone No.
            </th>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>
              Mail ID
            </th>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>
              Location
            </th>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>
              Bar Code No.
            </th>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>Court</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>
              {`${lawyer.first_name} ${lawyer.last_name}`}
            </td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>
              {lawyer.phone_number}
            </td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>
              {lawyer.email}
            </td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>
              {lawyer.city}
            </td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>
              {lawyer.barcode_id}
            </td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>
              {lawyer.court}
            </td>
          </tr>
        </tbody>
      </table>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: "20px",
        }}
      >
        <thead>
          <tr>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>
              Experience
            </th>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>
              Specialized
            </th>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>
              Office Address
            </th>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>
              Education Details
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>
              {lawyer.years_experience} years
            </td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>
              {lawyer.specialized}
            </td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>
              {`${lawyer.district}, ${lawyer.city}, ${lawyer.state} - ${lawyer.pincode}`}
            </td>
            <td style={{ border: "1px solid #ddd", padding: "8px" }}>
              {`${lawyer.course} from ${lawyer.college} (${lawyer.yr_passed_out})`}
            </td>
          </tr>
        </tbody>
      </table>

      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          marginBottom: "20px",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: "24px", fontWeight: "bold" }}>
            {lawyer.case_counts?.ongoing_cases || 0}
          </div>
          <div>Ongoing Cases</div>
        </div>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: "24px", fontWeight: "bold" }}>
            {lawyer.case_counts?.completed_cases || 0}
          </div>
          <div>Completed Cases</div>
        </div>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: "24px", fontWeight: "bold" }}>
            {lawyer.internship_counts?.ongoing || 0}
          </div>
          <div>Ongoing Interns</div>
        </div>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: "24px", fontWeight: "bold" }}>
            {lawyer.internship_counts?.completed || 0}
          </div>
          <div>Completed Interns</div>
        </div>
      </div>
    </div>
  );
};

export default LawyerDetails;